function Choices({ choices, onChoice, onNext, showNext }) {
  // Les choix ont toujours priorité sur le bouton continuer
  if (choices && choices.length > 0) {
    return (
      <div className="vn-choices">
        {choices.map((c, i) => (
          <button key={i} className="vn-choice" onClick={() => onChoice(c)}>
            {c.text}
          </button>
        ))}
      </div>
    );
  }

  if (showNext) {
    return (
      <div className="clearfix">
        <button className="vn-next" onClick={onNext}>
          Continuer →
        </button>
      </div>
    );
  }

  return null;
}

export default Choices;
